import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import Modal from 'kepler/lib/components/Modal';
import ModalBody from 'kepler/lib/components/ModalBody';
import { locationUpdate } from '../actions/action-contact-location';
import LogIn from '../components/LogIn';
import { closeModalContainer } from '../actions/action-login-modal';
import { resetStepUp } from '../actions/action-step-up';
import { dispatchLogin } from '../actions/action-login-redirect';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import i18n from '../../lib/reacti18n';
import * as shape from '../constants/PropTypesShapes';
import { chatType, MODAL_TYPE, modalChannels } from '../constants/UtilVariables';
import * as Page from '../../lib/page';

const CHANNEL_CHATBOT = chatType.chatBot;
const CHANNEL_LIVECHAT = chatType.liveChat;

const label = {
  confirm: i18n.message('smarthelp/chatBot.chatBot.error.ok'),
};

class ModalContainer extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  // Send FPTi request when intermediate page open
  componentDidUpdate() {
    if (this.props.isModalOpen) {
      trackPage({ id: this.props.FPTITrackerId, link: 'smarthelp-intermediate|open' });
    }
  }

  showLoginPage() {
    const pathname = encodeURIComponent(window.location.pathname.slice(3));
    const currentUri = `${Page.getOriginPath()}${pathname}`;
    const topic = {};

    if (this.props.channel === CHANNEL_CHATBOT || this.props.channel === CHANNEL_LIVECHAT || this.props.channel === modalChannels.call) {
      const topicRefId = _get(this.props.selectResult, 'topicTreeSelectResult.topicRefId');
      const topicId = _get(this.props.selectResult, 'topicTreeSelectResult.topicId');
      const topicName = _get(this.props.selectResult, 'topicTreeSelectResult.topicName');
      if (topicRefId && topicId && topicName) {
        topic.topicId = topicId;
        topic.topicName = topicName;
        topic.topicRefId = topicRefId;
      }
    }

    trackLink({ id: this.props.FPTITrackerId, link: `smarthelp-intermediate|login|${this.props.channel}` });
    return this.props.dispatchLogin(currentUri, this.props.channel, topic);
  }
  showGuestPage() {
    trackLink({ id: this.props.FPTITrackerId, link: `smarthelp-intermediate|guest|${this.props.channel}` });
    return this.props.locationUpdate({ pageName: 'callUs' });
  }

  closeModal() {
    sessionStorage.removeItem('chatBotClicked');
    sessionStorage.removeItem('liveChatClicked');
    trackLink({ id: this.props.FPTITrackerId, link: 'smarthelp-intermediate|close' });
    this.props.resetStepUp();
    return this.props.closeModalContainer();
  }

  // Render login prompt for selected Call/Email option in the logout cases
  renderLoginModal() {
    return (
      <LogIn
        content={this.props.content}
        channelType={this.props.channel}
        clickAction={() => this.showLoginPage()}
        linkAction={() => this.showGuestPage()}
      />
    );
  }

  // Render/prmopt message with the message of open message-type modal
  renderMessageModal() {
    return (
      <div className="text-center">
        <div className="login">{this.props.modalMessage}</div>
        <button className="login_btn btn" onClick={this.closeModal}>{label.confirm}</button>
      </div>
    );
  }

  // Render Modal Prompt
  renderModalPrompt() {
    if (this.props.modalType !== MODAL_TYPE.message) {
      return this.renderLoginModal();
    }

    // Showing message type modal
    return this.renderMessageModal();
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.isModalOpen} type="dialog" width="medium"
          onCancel={this.closeModal}
        >
          <ModalBody>
            {this.renderModalPrompt()}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  // emailUs--> Intent selected and email--> No intent selected
  const channels = {
    email: 'emailUs',
    callUs: 'callUs',
    emailUs: 'emailUs',
    chatBot: CHANNEL_CHATBOT,
    liveChat: CHANNEL_CHATBOT,
  };
  return {
    content: i18n.message(`smarthelp/${channels[state.modal.channel]}`),
    isModalOpen: state.modal.isModalOpen,
    modalType: state.modal.type,
    modalMessage: state.modal.message,
    channel: state.modal.channel,
    selectResult: state.selectResult,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeModalContainer, dispatchLogin, locationUpdate, resetStepUp }, dispatch);
}

ModalContainer.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  locationUpdate: PropTypes.func.isRequired,
  dispatchLogin: PropTypes.func.isRequired,
  closeModalContainer: PropTypes.func.isRequired,
  content: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  channel: PropTypes.string.isRequired,
  selectResult: PropTypes.shape(shape.SELECT_RESULT).isRequired,
  FPTITrackerId: PropTypes.string,
  modalType: PropTypes.string.isRequired,
  modalMessage: PropTypes.string.isRequired,
  resetStepUp: PropTypes.func.isRequired,
};

ModalContainer.defaultProps = {
  content: {
    login: {
      guestMessage: '',
      header: '',
      instruction: '',
      login: '',
      loginMessage: '',
      message: '',
      trouble: '',
    },
  },
  FPTITrackerId: 'intermediatePage',
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalContainer);
